module.exports = __webpack_public_path__ + "img/Application-Scenarios-6.cf2e9bf.jpg";